<!--<div style="padding: 1.5rem !important;">
  <h4 class="font-weight-bold py-3 mb-4">
    Dashboard
    <div class="text-muted text-tiny mt-1"><small class="font-weight-normal" [innerHTML]="formatarDataExtenso()"></small></div>
  </h4>

  <div class="row">
    <div class="col-sm-6 col-xl-3">

      <div class="card mb-4" style="min-height: 85%;">
        <div class="card-body">
          <div class="ml-5" style="text-align:end;cursor:pointer;margin-top:-15px;" (click)="detalharTitulos('cr')">...</div>
          <div class="d-flex align-items-center">
            <div class="display-4 text-success"><i class="fas fa-hand-holding-usd text-success"></i></div>
            <div class="ml-3">
              <div class="text-muted small">Títulos à Receber Hoje</div>
              <div class="text-large">{{ valorRcbtos | money }}
                </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="col-sm-6 col-xl-3">

      <div class="card mb-4" style="min-height: 85%;">
        <div class="card-body">
          <div class="ml-5" style="text-align:end;cursor:pointer;margin-top:-15px;" (click)="detalharTitulos('cp')">...</div>
          <div class="d-flex align-items-center">
            <div class="display-4 text-danger">
                <img src="data:image/svg+xml;utf8;base64,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" />
            </div>
            <div class="ml-3">
              <div class="text-muted small">Títulos à Pagar Hoje</div>
              <div class="text-large">{{ valorPgtos | money }}</div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="col-sm-6 col-xl-3">

      <div class="card mb-4" style="min-height: 85%;">
        <div class="card-body">
            <div class="ml-5" style="text-align:end;cursor:pointer;margin-top:-15px;" (click)="detalharTitulosVencidos('cr')">...</div>
          <div class="d-flex align-items-center">
            <div class="display-4 text-success"><i class="fas fa-search-dollar"></i></div>
            <div class="ml-3">
              <div class="text-muted small">Títulos Vencidos à Receber</div>
              <div class="text-large">{{ totalTitVencidoRcto | money }}</div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="col-sm-6 col-xl-3">

      <div class="card mb-4" style="min-height: 85%;">
        <div class="card-body">
            <div class="ml-5" style="text-align:end;cursor:pointer;margin-top:-15px;" (click)="detalharTitulosVencidos('cp')">...</div>
          <div class="d-flex align-items-center">
            <div class="display-4 text-danger"><i class="fas fa-search-dollar"></i></div>
            <div class="ml-3">
              <div class="text-muted small">Títulos Vencidos à Pagar</div>
              <div class="text-large">{{ totalTitVencidoPgto | money }}</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="card mb-4 ">
    <h6 class="card-header with-elements">
      <div class="card-header-title col-9" >Gráfico Evolução Saldo </div>
      <div class="card-header-elements ml-auto col-3 pr-0">
        <div class="text m-0 p-0 col">
          <span class="text-light text-tiny font-weight-semibold align-middle" style="color:#ababab !important;">CONTA</span>
            <p-dropdown  class="type-p-dropdown " [filter]="true" [options]="opcoesContas" [(ngModel)]="contaId" (onChange)="alternarContas()"  placeholder="Selecione"></p-dropdown>
        </div>
      </div>
    </h6>

    <div class="row no-gutters row-bordered">
      <div class="col-md-8 col-lg-12 col-xl-8">
        <div class="card-body">
          <div style="height:210px">
            <canvas class="chart-width" id="saldoMes" baseChart height="210"
              [datasets]="chartData"
              [labels]="chartLabels"
              [options]="chartOptions"
              [chartType]="'line'"
              [colors]="chartColors">
            </canvas>
          </div>
        </div>
      </div>

      <div class="col-md-4 col-lg-12 col-xl-4">
        <div class="card-body">

          <div class="row">
            <div class="col-6 col-xl-5 text-muted mb-3">Conta Corrente</div>
            <div class="col-6 col-xl-7 mb-3">
              <span class="text-big {{saldoCC > 0 ? '' : 'text-danger' }}">R$ {{ saldoCC | money  }}</span>
            </div>
            <div class="col-6 col-xl-5 text-muted mb-3">Investimento</div>
            <div class="col-6 col-xl-7 mb-3">
              <span class="text-big {{saldoInvest > 0 ? '' : 'text-danger' }}">R$ {{ saldoInvest | money }}</span>
            </div>
            <div class="col-6 col-xl-5 text-muted mb-3">Caixinha</div>
            <div class="col-6 col-xl-7 mb-3">
              <span class="text-big {{saldoCaixinha > 0 ? '' : 'text-danger' }}">R$ {{ saldoCaixinha | money }}</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="card mb-4 ">
    <h6 class="card-header with-elements">
      <div class="card-header-title col-9" >Gráfico Evolução Diária</div>
      <div class="card-header-elements ml-auto col-3 pr-0">
        <label class="text m-0 p-0 col"> </label>
      </div>
    </h6>

    <div class="row no-gutters row-bordered">
      <div class="col-md-12 col-lg-12 col-xl-12">
        <div class="card-body">
          <div style="height:210px;">
            <canvas class="chart-width" id="saldoDiario" baseChart height="210"
              [datasets]="chartDataDay"
              [labels]="chartLabelsDay"
              [options]="chartOptions"
              [chartType]="'line'"
              [colors]="chartColorsDay">
            </canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="{{ tituloModal }}" [(visible)]="modalRecebimentos || modalPagamentos"
          [style]="{width: '1000px', height: '550px'}"
          [modal]="true"
          styleClass="dashboard-altura-inicial"
          [responsive]="true"
          appendTo="body"
          [closable]="true" (onHide)="resetModal()">
  <div *ngIf="relTitulos">
    <p-dataTable class="table-filter" [scrollable]="true" scrollHeight="300px" #dt [value]="relTitulos" [rows]="rows" [paginator]="false" [pageLinks]="pageLinks"
      [rowsPerPageOptions]="rowsPerPage" selectionMode="single" emptyMessage="Nenhum Registro Encontrado">
      <p-header class="clearfix">
          <div class="pull-right align-down-table">
              <button type="button" class="btn btn-link" (click)="dt.exportCSV()"><i
                  class="fas fa-file-excel excel"></i> Exportar para Excel</button>
          </div>
      </p-header>
      <div class="clearfix"></div>
       <p-column [style]="{'text-align': 'center', 'width': '10%' }" header="VENCTO" field="dt_vcto" [filter]="true" filterMatchMode="contains">
        <ng-template let-rowValue="rowData" pTemplate="body">
          <tr>
            <td [style]="{'text-align': 'center'}">{{rowValue.dt_vcto}}</td>
          </tr>
        </ng-template>
      </p-column>
      <p-column [style]="{'text-align': 'center', 'width': '10%' }" header="PREV/BAIXA" field="dt_previsao" [filter]="true" filterMatchMode="contains">
        <ng-template let-rowValue="rowData" pTemplate="body">
          <tr>
            <td [style]="{'text-align': 'center'}">{{rowValue.dt_previsao}}</td>
          </tr>
        </ng-template>
      </p-column>
      <p-column [style]="{'white-space':'nowrap', 'overflow': 'hidden', 'width':'12%', 'text-align': 'left', 'text-overflow':'ellipsis'}" header="NOME" field="nome" [filter]="true" filterMatchMode="contains">
        <ng-template let-rowValue="rowData" pTemplate="body">
          <span matTooltip="{{rowValue.nome}}">{{rowValue.nome}}</span>
        </ng-template>
      </p-column>
      <p-column [style]="{'white-space':'nowrap', 'overflow': 'hidden', 'width':'12%', 'text-align': 'left', 'text-overflow':'ellipsis'}" header="OPERAÇÃO" field="operacao" [filter]="true" filterMatchMode="contains">
        <ng-template let-rowValue="rowData" pTemplate="body">
          <span matTooltip="{{rowValue.operacao}}">{{rowValue.operacao}}</span>
        </ng-template>
      </p-column>
      <p-column [style]="{'white-space':'nowrap', 'overflow': 'hidden', 'width':'18%', 'text-align': 'left', 'text-overflow':'ellipsis'}" header="HISTÓRICO" field="historico" [filter]="true" filterMatchMode="contains">
        <ng-template let-rowValue="rowData" pTemplate="body">
          <span matTooltip="{{rowValue.historico}}">{{rowValue.historico}}</span>
        </ng-template>
      </p-column>
      <p-column [style]="{'width':'10%', 'text-align': 'left' }" header="DOC" field="nf" [filter]="true" filterMatchMode="contains">
        <ng-template let-rowValue="rowData" pTemplate="body">
          <tr>
            <td>{{rowValue.nf}}</td>
          </tr>
        </ng-template>
      </p-column>
      <p-column [style]="{'width':'5%','text-align': 'center' }" header="Parcela" field="parcela" [filter]="true" filterMatchMode="contains">
        <ng-template let-rowValue="rowData" pTemplate="body">
          <tr>
            <td>{{rowValue.parcela}}</td>
          </tr>
        </ng-template>
      </p-column>
      <p-column [style]="{'width':'10%', 'text-align': 'right' }" header="Valor&nbsp;&nbsp;" field="valor" [filter]="true" filterMatchMode="contains">
        <ng-template let-rowValue="rowData" pTemplate="body">
          <tr>
            <td>{{rowValue.valor | money}}</td>
          </tr>
        </ng-template>
      </p-column>
      <p-column [style]="{'width':'13%', 'text-align': 'center' }" header="Status" field="status" [filter]="true" filterMatchMode="contains">
        <ng-template let-rowValue="rowData" pTemplate="body">
          <tr>
            <td>{{rowValue.status}}</td>
          </tr>
        </ng-template>
      </p-column>
    </p-dataTable>
  </div>
</p-dialog>

<p-dialog header="{{ tituloModal }}" [(visible)]="modalVencidos"
      [style]="{width: '1000px', height: '550px'}"
      height="550"
      [modal]="true"
      [closable]="true"
      styleClass="dashboard-altura-inicial"
      [responsive]="true"
      appendTo="body"
      [closable]="true" (onHide)="resetModal()">
  <div *ngIf="vencidos">
    <p-dataTable class="table-filter" [scrollable]="true" scrollHeight="300px" [value]="vencidos" [rows]="rows" [paginator]="false" [pageLinks]="pageLinks"
      [rowsPerPageOptions]="rowsPerPage" selectionMode="single" emptyMessage="Nenhum Registro Encontrado">
      <p-header class="clearfix">
          <div class="pull-right align-down-table">
              <button type="button" class="btn btn-link" (click)="dt.exportCSV()"><i
                  class="fas fa-file-excel excel"></i> Exportar para Excel</button>
          </div>
    </p-header>
    <div class="clearfix"></div>
      <p-column [style]="{'text-align': 'center', 'width': '10%' }" header="DATA VENCTO" field="dt_vcto" [filter]="true" filterMatchMode="contains">

        <ng-template let-rowValue="rowData" pTemplate="body">
          <tr>
            <td [style]="{'text-align': 'center'}">{{rowValue.dt_vcto}}</td>
          </tr>
        </ng-template>
      </p-column>
      <p-column [style]="{'text-align': 'center', 'width': '10%' }" header="DATA PREV/BAIXA" field="dataBaixaPrev" [filter]="true" filterMatchMode="contains">
        <ng-template let-rowValue="rowData" pTemplate="body">
          <tr>
            <td [style]="{'text-align': 'center'}">{{rowValue.dataBaixaPrev}}</td>
          </tr>
        </ng-template>
      </p-column>
      <p-column [style]="{'white-space':'nowrap', 'overflow': 'hidden', 'width':'12%', 'text-align': 'left', 'text-overflow':'ellipsis'}" header="NOME" field="nome" [filter]="true" filterMatchMode="contains">
        <ng-template let-rowValue="rowData" pTemplate="body">
          <span matTooltip="{{rowValue.nome}}">{{rowValue.nome}}</span>
        </ng-template>
      </p-column>
      <p-column [style]="{'white-space':'nowrap', 'overflow': 'hidden', 'width':'15%', 'text-align': 'left', 'text-overflow':'ellipsis'}" header="OPERAÇÃO" field="operacao" [filter]="true" filterMatchMode="contains">
        <ng-template let-rowValue="rowData" pTemplate="body">
          <span matTooltip="{{rowValue.operacao}}">{{rowValue.operacao}}</span>
        </ng-template>
      </p-column>
      <p-column [style]="{'width':'10%', 'text-align': 'left' }" header="DOC" field="nf" [filter]="true" filterMatchMode="contains">
        <ng-template let-rowValue="rowData" pTemplate="body">
          <tr>
            <td>{{rowValue.nf}}</td>
          </tr>
        </ng-template>
      </p-column>
      <p-column [style]="{'width':'5%','text-align': 'center' }" header="Parcela" field="parcela" [filter]="true" filterMatchMode="contains">
        <ng-template let-rowValue="rowData" pTemplate="body">
          <tr>
            <td>{{rowValue.parcela}}</td>
          </tr>
        </ng-template>
      </p-column>
      <p-column [style]="{'width':'10%', 'text-align': 'right' }" header="Valor&nbsp;&nbsp;" field="valor" [filter]="true" filterMatchMode="contains">
        <ng-template let-rowValue="rowData" pTemplate="body">
          <tr>
            <td>{{rowValue.valor | money}}</td>
          </tr>
        </ng-template>
      </p-column>
      <p-column [style]="{'width':'15%', 'text-align': 'center' }" header="Status" field="status" [filter]="true" filterMatchMode="contains">
        <ng-template let-rowValue="rowData" pTemplate="body">
          <tr>
            <td>{{rowValue.status}}</td>
          </tr>
        </ng-template>
      </p-column>
    </p-dataTable>
  </div>
</p-dialog>-->

<div class="bi" id="pbi-report" #powerBIReports></div>
